import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import BreadcrumbClient from "../../components/Common/BreadcrumbClient"
import { withTranslation } from "react-i18next"
//import Lead from "./Lead";
import ClientLink from "./client-link";
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getClientDetail, addClientBuyerPref} from "../../store/clients/actions"

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup
} from "reactstrap"
import ClientSidebar from "components/VerticalLayout/ClientSidebar";
import SaveButton from "components/buttons/save";
import RsLink from "components/buttons/rsLink";
import ClientBuyerBreadcrumbs from "components/Common/ClientBuyerBreadcrumb";
import ClientBuyerMenu from "./menu/client-buyer-menu";
import { API_URL } from "helpers/app_url";
import NoAccess from "components/NoAccess";
import CurrencyInput from "react-currency-input-field";
import SafeField from "helpers/SafeField";


class ClientBuyPref extends Component {
  constructor(props) {
    super(props)
    this.state = {
        selectedGroup: null,
        buyersQuestions: [],
        buyersData: [],
        selectedvalue: '',
    }
    this.handleSelectGroup = this.handleSelectGroup.bind(this)
    this.handleValidSubmit = this.handleValidSubmit.bind(this)
  }
  handleSelectGroup = selectedGroup => {
    this.setState({ selectedGroup })
  }
  handleValidSubmit(event, values) {

    this.props.addClientBuyerPref(values, this.props.history)
    //
  }
  componentDidMount() {
    const { match: { params }, onGetClientDetail } = this.props;
    onGetClientDetail(params.clientId);
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str =  `Bearer ${token}`;
    const authHeader = { Authorization: `Bearer ${token}` };
      axios.get( API_URL + `QuestionAnswer/allforagenttype`, {
        params: {
          forType: 1,
          agentId: localStorage.getItem('userId')

        }, headers: { Authorization: str }
      })
      .then(res => {
        const buyersQuestions = res.data;
        this.setState({ buyersQuestions });
      });
      axios.get( API_URL + `ClientQuestionAnswer/all`, {
        params: {
          ClientId: this.props.match.params.id,
          agentId: localStorage.getItem('userId')
       
        }, headers: { Authorization: str }
      })
        .then(res => {
          const buyerAnswers = res.data;
          this.setState({ buyerAnswers });
        });
  }
  handleSubmit(values) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str =  `Bearer ${token}`;
    toast.loading("Please wait...")
    fetch(`${API_URL}ClientQuestionAnswer/bulkadd`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': str,
      },
      body: JSON.stringify(values)
    })
    .then(response => response.json())
    .then(data => {
     
      if (data.success) {

         toast.dismiss();
          toast.success("Saved successfully!");
      } else {
         toast.dismiss();
          toast.error("Failed to submit questions. Please try again.");
      }
  })
  .catch(error => {
      toast.dismiss();
      toast.error("Error occurred while submitting. Please try again.");
        console.error('Error:', error);
  });
  }

  handleUpdate(values) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj.resultData.bearerToken;
    const str =  `Bearer ${token}`;
    toast.loading("Please wait...")
    fetch(`${API_URL}ClientQuestionAnswer/bulkadd`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': str,
      },
      body: JSON.stringify(values)
    })
    .then(response => response.json())
    .then(data => {
     
      if (data.success) {
        toast.dismiss();
          toast.success("Updated successfully!");
      } else {
         toast.dismiss();
          toast.error("Failed to update questions. Please try again.");
      }
  })
  .catch(error => {
      toast.dismiss();
      toast.error("Error occurred while updating. Please try again.");
        console.error('Error:', error);
  });
  }
  render() {
   
    const { clietDetail, userdetail, isResponsive } = this.props;
    const hasBuyerType = clietDetail.clientTypes && clietDetail.clientTypes.some((type) => type.clientTypeCode === 1);
    return (
      <React.Fragment>
             <ToastContainer autoClose={2000} />
       <div className="page-content project-page-content">
          <MetaTags>
            <title>Client Dashboard | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
          {hasBuyerType ? (
            <Row>
              <Col sm='2' className="pe-0">
                <ClientSidebar id={this.props.match.params.id} clientId={this.props.match.params.clientId} clientDetail={clietDetail} isResponsive={isResponsive} />
              </Col>
              <Col sm='10' className="">
              <Row className="project-header">
                <Col sm="7">
             <ClientBuyerBreadcrumbs
              title={this.props.t("Clients")}
              breadcrumbItem={this.props.t( " Preference")}
            />
            </Col>
            <Col sm="4" className="">
                <h2 className="">{this.props.t( clietDetail.firstName + " " + clietDetail.lastName)}</h2>
                </Col>
            </Row>
            <ClientBuyerMenu isResponsive={isResponsive} />
            <Row>
            {/* <Col xl="3">
            <ClientLink id={this.props.match.params.id} clientId={this.props.match.params.clientId} />
              </Col> */}
              
            <Col xl="12">
           
                        <Card className="border-full">
                        <Formik
                enableReinitialize={true}
                initialValues={{
                  agentId: parseInt(localStorage.getItem('userId')),
                  questionAnswers: this.state.buyersQuestions.reduce((acc, question) => {
                    const answer = this.state.buyerAnswers?.find(
                      (ans) => ans.questionAnswerId === question.id
                    );
                    acc[question.id] = { answersOption: answer?.answersOption || '' };
                    return acc;
                  }, {})
                  }}

                validationSchema={ Yup.object().shape({
                  
                })}
                onSubmit={(values) => {
                  const addAnswers = [];
                  const updateAnswers = [];
                  this.state.buyersQuestions.forEach((question) => {
                    const existingAnswer = this.state.buyerAnswers?.find(
                      (ans) => ans.questionAnswerId === question.id
                    );
            
                    const answerObj = {
                      ClientId: parseInt(this.props.match.params.id),
                      agentId: parseInt(localStorage.getItem('userId')),
                      questionAnswerId: parseInt(question.id),
                      answersOption: values.questionAnswers[question.id]?.answersOption || '',
                      isActive: true
                    };
                    if (existingAnswer) {
                      updateAnswers.push({
                        ...answerObj,
                        id: existingAnswer.id,
                        contactQuestionAnswerId	:existingAnswer.contactQuestionAnswerId,
                      });
                    } else {
                      addAnswers.push(answerObj);
                    }
                  });
                  const addPayload = { questionAnswers: addAnswers };
                  const updatePayload = { questionAnswers: updateAnswers };
                  if (addAnswers.length > 0) {
                    this.handleSubmit(addPayload);
                  }
                  if (updateAnswers.length > 0) {
                    this.handleUpdate(updatePayload);
                  }
                }}
            >
                {({ errors,  touched, values, handleChange, setFieldValue }) => (
                    <Form className="needs-validation">
                        <CardBody>
                       
                        <div className="row mb-3">
                            {
                                              this.state.buyersQuestions
                                                .map(buyersQuestion =>

                                                  <div key={buyersQuestion.key} className={buyersQuestion.layoutClass}>
                                                    <FormGroup>

                                                      <Label htmlFor={`questionAnswers.${buyersQuestion.id}.answersOption`}>
                                                        {buyersQuestion.question}
                                                      </Label>
                                                      {(() => {
                                                        if (buyersQuestion.questionType == 1) {

                                                          const asns = buyersQuestion.answersOptions;
                                                          const res = asns.split(',');
                                                          const result = res.map((item, index) => <option key={index} value={item}



                                                          >{item}</option>);
                                                          return (
                                                            <div>
                                                              <SafeField as="select" className="form-control" name={`questionAnswers.${buyersQuestion.id}.answersOption`}>
                                                                <option value="">Select</option>
                                                                {result}
                                                              </SafeField>
                                                            </div>
                                                          )
                                                        } else if (buyersQuestion.questionType == 2) {

                                                          return (

                                                              <SafeField
                                                                name={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                                type="checkbox"
                                                                id={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                                className="questCheckbox"
                                                                onChange={(e) => setFieldValue(
                                                                    `questionAnswers.${buyersQuestion.id}.answersOption`,
                                                                    e.target.checked ? 'Yes' : 'No'
                                                                  )}

                                                              />



                                                          )
                                                        } else if (buyersQuestion.questionType == 6) {
                                                          return (
                                                            <div>
                                                             <SafeField
                                                                name={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                                type="text"
                                                                onChange={handleChange}
                                                                className="form-control"

                                                              />
                                                            </div>
                                                          )
                                                        } else if (buyersQuestion.questionType == 7) {
                                                          return (
                                                            <div>
                                                              <SafeField
                                                                name={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                                type="text"
                                                                onChange={handleChange}
                                                                className="form-control"

                                                              />
                                                            </div>
                                                          )
                                                        }
                                                      else if (buyersQuestion.questionType == 10) {
                                                        return (
                                                          <div>
                                                          
                                                            <CurrencyInput
                                                              id={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                              name={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                              className="form-control"
                                                              value={values.questionAnswers[buyersQuestion.id]?.answersOption || ''}
                                                              onValueChange={(value) => setFieldValue(`questionAnswers.${buyersQuestion.id}.answersOption`, value)}
                                                              prefix={userdetail?.agentDefaultCurrencyCode + " "}
                                                              decimalsLimit={2}
                                                              />
                                                          </div>
                                                        )
                                                      } 
                                                        else if (buyersQuestion.questionType == 8) {
                                                          return (
                                                            <div>
                                                              <SafeField as="textarea" name={`questionAnswers.${buyersQuestion.id}.answersOption`} className="form-control" onChange={handleChange} />

                                                            </div>
                                                          )
                                                        } else if (buyersQuestion.questionType == 9) {
                                                          return (
                                                            <div>
                                                              <SafeField
                                                                name={`questionAnswers.${buyersQuestion.id}.answersOption`}
                                                                type="text"
                                                                onChange={handleChange}
                                                                className="form-control"

                                                              />
                                                            </div>
                                                          )
                                                        }else {
                                                          return (
                                                            <div></div>
                                                          )
                                                        }
                                                      })()}



                                                    </FormGroup>
                                                  </div>



                                                )}



                                    </div>

                                    <hr className="mt-2 mb-3" />


                            <Row className="mb15">
                                <Col sm="12" md="6">
                                    <SaveButton>Save Questions</SaveButton>

                                </Col>

                                <Col
                                    sm="12"
                                    md="6"
                                    className="text-end"
                                >


                                </Col>
                            </Row>
                        </CardBody>
                    </Form>
                )}
            </Formik>
                        </Card>
            </Col>
            
            </Row>
            </Col>
            </Row>
            ) : (
              <NoAccess />
             
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
ClientBuyPref.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
  match: PropTypes.object,
  onGetClientDetail:PropTypes.func,
  clietDetail: PropTypes.object,
  addClientBuyerPref:PropTypes.func,
  userdetail:PropTypes.object,
  isResponsive:PropTypes.object
}
const mapStateToProps = ({ Clients }) => (
  {
    clietDetail: Clients.clietDetail,
   

  })
const mapDispatchToProps = dispatch => ({
  onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
  addClientBuyerPref:(data) => dispatch(addClientBuyerPref(data))
 
});
export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(ClientBuyPref))
